import React, { useState, useEffect } from "react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import axios from "axios";
import { Link } from 'react-router-dom'
import usePageSEO from '../hooks/usePageSEO'
import Loader from '../components/Loader'


const Blog = () => {
  const [loading, setLoading] = useState(true);  
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;

  const [data, setData] = useState([])
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const apiUrl = apiBaseUrl+`posts`;

  const fetchInfo = () => {
    return axios.get(apiUrl).then((res) => {
      setData(res.data.posts)
      setMetaTitle(res.data.blogpage.meta_title);
      setMetaDescription(res.data.blogpage.meta_description);      
    });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  }) 

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  };


  return (
    <>
    <Header/>
    { loading && (<Loader /> )}
    <section className="section-content-block">
      <div className="container">
        <div className="row">
            {data.map((post, index) => {
              return (
                <div className="col-sm-4" key={index}>      
                    <Link className="casestudies" to={`/blog/details/${post.slug}`} onClick={scrollToTop}>
                      <img src={`${siteUrl}${post.image}`} alt={post?.slug} /> 
                      <p className="blue"><small>{post?.author_name} <span className="pull-right">{post?.post_date}</span></small></p>
                      <p>{post?.post_title}</p>
                    </Link>                              
                </div>             
              );
            })}
        </div>
      </div>
    </section>


    <Footer/>
    </>
  )
}

export default Blog